export const enumStatus = {
  Inactive: 0,
  Active: 1
};
